// extracted by mini-css-extract-plugin
module.exports = {"root":"PaginationAndListingsCount_root__gdRkE"};